import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import {DocumentViewModel} from '../../../documents/models/document.view-model';
import {PageViewModel} from '@components/ui/table-template/models/page-view-model';

@Component({
    selector: 'app-entity-document-card',
    templateUrl: './entity-document-card.component.html',
    styleUrls: ['./entity-document-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EntityDocumentCardComponent {
    public readonly currentPage = input.required<PageViewModel<DocumentViewModel>>();
    public readonly buttonClicked = output<DocumentViewModel>();

}
